module.exports = __webpack_public_path__ + "static/media/down_arrow.023790d2.png";